function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useRef, useState } from 'react';
import { createAssignSharedRefs } from 'utilities/input.helpers';
import { MinusCircleIcon } from 'components/Icon/MinusCircle';
import { PlusCircleIcon } from 'components/Icon/PlusCircle';
import { InputControl } from 'components/InputControl/InputControl';
const MAX_INPUT_DEFAULT = 999999999999999;
const NumberInput = /*#__PURE__*/React.forwardRef(({
  onChangeValue,
  min = 0,
  max = MAX_INPUT_DEFAULT,
  step = 1,
  allowTyping = true,
  value,
  defaultValue = 0,
  ...props
}, ref) => {
  const internalRef = useRef(null);
  const [internalValue, setInternalValue] = useState(() => {
    if (!value || isNaN(+value)) {
      return defaultValue;
    }
    return value;
  });
  const assignSharedRefs = createAssignSharedRefs(ref, internalRef);
  const handleChange = e => {
    const nextValue = +e.target.value;
    const result = nextValue < min ? min : nextValue > max ? max : nextValue;
    setInternalValue(result);
    if (onChangeValue) {
      onChangeValue(result);
    }
  };
  const getNextValue = increment => {
    if (!value || isNaN(+value)) {
      return +internalValue + increment;
    }
    return +value + increment;
  };
  const onControllerClick = action => {
    const increment = action === 'up' ? 1 : -1;
    const nextValue = getNextValue(increment);
    const result = nextValue < min ? min : nextValue > max ? max : nextValue;
    setInternalValue(result);
    if (onChangeValue) {
      onChangeValue(result);
    }
  };

  // The mousedown event will be fired before focus is lost otherwise we lose focus by clicking on controller.
  const handleMouseDown = e => {
    e.preventDefault();
    internalRef.current?.focus();
  };
  const handleKeyDown = e => {
    if (!allowTyping && !['ArrowUp', 'ArrowDown'].includes(e.key)) {
      e.preventDefault();
      e.stopPropagation();
    }
  };
  return /*#__PURE__*/React.createElement(InputControl, _extends({
    type: "number",
    autoComplete: "off",
    ref: assignSharedRefs,
    min: min,
    max: max,
    step: step,
    value: value ?? internalValue.toString(),
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    startAdornment: /*#__PURE__*/React.createElement("div", {
      onMouseDown: handleMouseDown,
      onClick: () => onControllerClick('down')
    }, /*#__PURE__*/React.createElement(MinusCircleIcon, null)),
    endAdornment: /*#__PURE__*/React.createElement("div", {
      onMouseDown: handleMouseDown,
      onClick: () => onControllerClick('up')
    }, /*#__PURE__*/React.createElement(PlusCircleIcon, null))
  }, props));
});
export { NumberInput };